<template lang="html">
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button @click="login" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row>
                    <b-col md="6" sm="12">
                      <button-component
                        label="Conectar com Facebook"
                        classes="btn-primary btn-facebook"
                        icon="facebook"
                        :href="apiUrl"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <a @click.native="loginGoogle" class='btn btn-lg btn-danger' :href="apiUrlGoogle" style="margin-top: 10px;">
                      <i class="fab fa-google fa-fw"></i>
                      &nbsp;&nbsp;Login com Google
                    </a>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import Button from '../../button/Button.vue'
import Input from '../../form/Input'

export default {
  components: {
    'button-component': Button,
    'input-component': Input
  },
  data () {
    return {
      apiUrl: process.env.API + '/oauth/authenticate/facebook?' + (this.$route.query.invite ? 'hash=' + this.$route.query.invite + '&' : '') + (document.referrer ? 'prevref=' + document.referrer + '&' : '') + 'callback=' + process.env.FRONTEND_URL + '/%23/pages/login%3Ftoken=',
      apiUrlGoogle: process.env.API + '/oauth/authenticate/google?' + (this.$route.query.invite ? 'hash=' + this.$route.query.invite + '&' : '') + (document.referrer ? 'prevref=' + document.referrer + '&' : '') + 'callback=' + process.env.FRONTEND_URL + '/%23/pages/login%3Ftoken=',
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      // this.$auth.logout({
      //   makeRequest: false,
      //   success () {
      //     console.log('success ' + this.context)
      //     // this.$router.replace('/login')
      //
      //   },
      //   error () {
      //     console.log('error ' + this.context)
      //   }
      // })
      this.$auth.login({
        body: {username: this.username, password: this.password},
        rememberMe: true,
        params: {},
        redirect: '/',
        success: function (res) {
          console.log('ok ' + this.$auth.token())
          console.log('Auth: ' + this.$auth.check('ROLE_USER'))
          console.log('Auth: ' + this.$auth.check('ROLE_ADMIN'))
          console.log('Auth: ' + this.$auth.check('ROLE_SUPER'))
          this.$router.replace('/wizard')
        },
        error: function () {
          console.log('error')
        }
      })
    }
  }
}
</script>

<style lang="scss">
  /*.card-login {*/
  /*.card-action {*/
  /*max-width: 300px;*/
  /*margin: 0 auto;*/
  /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/login/Login.vue